import MileageUpdateRequest, {
  MileageUpdateRequestAddressSequenceNode,
  MileageUpdateRequestStatusType,
  MileageUpdateRequestVehicleType,
} from "../../../api/raily/mileage/update/mileage-update-request";
import MileageStatus from "../../../types/mileage-status";
import VehicleType from "../../../types/vehicle-type";
import MileageUpdateParams, {
  MileageUpdateParamsNode,
} from "./mileage-update-params";

const createAddressNode = (
  node: MileageUpdateParamsNode,
): MileageUpdateRequestAddressSequenceNode => {
  return {
    displayName: node.displayName,
    lat: node.lat,
    lon: node.lon,
    time: node.time,
    apartmentNumber: node.apartmentNumber,
    houseNumber: node.houseNumber,
    street: node.street,
    town: node.town,
    zipCode: node.zipCode,
    distance: node.distance,
  };
};

const createAddressNodes = (
  nodes: MileageUpdateParamsNode[] | undefined,
): MileageUpdateRequestAddressSequenceNode[] | undefined => {
  if (!nodes) {
    return undefined;
  }
  const requestNodes: MileageUpdateRequestAddressSequenceNode[] =
    nodes.map(createAddressNode);

  return requestNodes;
};

const createVehicleType = (
  type: VehicleType | undefined,
): MileageUpdateRequestVehicleType | undefined => {
  switch (type) {
    case VehicleType.CAR_GT_900CM3:
      return MileageUpdateRequestVehicleType.CAR_GT_900CM3;
    case VehicleType.CAR_LE_900CM3:
      return MileageUpdateRequestVehicleType.CAR_LE_900CM3;
    case VehicleType.COMPANY_OWNED:
      return MileageUpdateRequestVehicleType.COMPANY_OWNED;
    case VehicleType.MOPED:
      return MileageUpdateRequestVehicleType.MOPED;
    case VehicleType.MOTORCYCLE:
      return MileageUpdateRequestVehicleType.MOTORCYCLE;
    default:
      return undefined;
  }
};

const createStatusType = (
  type: MileageStatus | undefined,
): MileageUpdateRequestStatusType | undefined => {
  switch (type) {
    case MileageStatus.ACCEPTED:
      return MileageUpdateRequestStatusType.ACCEPTED;
    case MileageStatus.DELEGATION_CREATED:
      return MileageUpdateRequestStatusType.DELEGATION_CREATED;
    case MileageStatus.PENDING:
      return MileageUpdateRequestStatusType.PENDING;
    case MileageStatus.REJECTED:
      return MileageUpdateRequestStatusType.REJECTED;
    default:
      return undefined;
  }
};

const create = (params: MileageUpdateParams): MileageUpdateRequest => {
  return {
    mileageUuid: params.mileageUuid,
    mileageDate: params.mileageDate,
    distance: params.distance,
    state: createStatusType(params.state),
    vehicleType: createVehicleType(params.vehicleType),
    updateReason: params.updateReason,
    addressSequence: createAddressNodes(params.addressSequence),
    acceptedDistance: params.acceptedDistance,
    osrmDistance: params.osrmDistance,
  };
};

const mileageUpdateParamsFactory = {
  create,
};

export default mileageUpdateParamsFactory;
